// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"aa685500","425":"1eaa2840","510":"ac9d27fd","532":"414d80e7","633":"458af2de","634":"e7cb6c8c","922":"0d487912","937":"c49727f4","972":"9b9f7f8e"}[chunkId] + ".chunk.js";
};